import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Icon,
  IconButton
} from '@material-ui/core';


interface IDesignedInfoDialog {
  title?: string,
  children: React.ReactNode,
  open: boolean,
  // eslint-disable-next-line no-unused-vars
  setOpen: (arg: boolean) => void,
}

const DesignedInfoDialog = (
  { title, children, open, setOpen }: IDesignedInfoDialog
) => {
  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="info-dialog"
      PaperProps={{
        className: 'border-radius-6'
      }}
      fullWidth
      maxWidth={'sm'}
    >
      <DialogTitle id="confirm-dialog" className="flex-column w-full p-3">
        <div className="flex justify-end">
          <IconButton
            size="small"
            onClick={() => setOpen(false)}
          >
            <Icon fontSize="small">close</Icon>
          </IconButton>
        </div>
        <div className="px-10 text-center text-18 font-bold">{title}</div>
      </DialogTitle>
      <DialogContent className="text-center px-8 pb-5">{children}</DialogContent>
    </Dialog>
  );
};

export default DesignedInfoDialog;
